"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const context_1 = require("./lib/context");
function useError(options) {
    const { getErrorMessage } = options || {};
    const [errorMessage, setErrorMessage] = (0, react_1.useState)('');
    const [isErrored, setIsErrored] = (0, react_1.useState)(false);
    const errorCtx = (0, react_1.useContext)(context_1.ErrorContext);
    function resetError() {
        setErrorMessage('');
        setIsErrored(false);
    }
    function setError(error) {
        let gerErrorMessageFn = getErrorMessage || errorCtx.getErrorMessage;
        if (!error)
            return resetError();
        if (typeof error === 'string')
            error = new Error(error);
        const apiError = gerErrorMessageFn(error);
        setErrorMessage(apiError);
        setIsErrored(true);
    }
    return { error: errorMessage, isErrored, setError, resetError };
}
exports.default = useError;
